import _defineProperty from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Box } from '..';
import VisuallyHidden from '../_VisuallyHidden';
import { Slot } from './slots';

var CheckboxOrRadioGroupLabel = function CheckboxOrRadioGroupLabel(_ref) {
  var children = _ref.children,
      visuallyHidden = _ref.visuallyHidden,
      sx = _ref.sx;
  return /*#__PURE__*/React.createElement(Slot, {
    name: "Label"
  }, function (_ref2) {
    var required = _ref2.required,
        disabled = _ref2.disabled;
    return /*#__PURE__*/React.createElement(VisuallyHidden, {
      isVisible: !visuallyHidden,
      title: required ? 'required field' : undefined,
      sx: _objectSpread({
        display: 'block',
        color: disabled ? 'fg.muted' : undefined,
        fontSize: 2
      }, sx)
    }, required ? /*#__PURE__*/React.createElement(Box, {
      display: "flex",
      as: "span"
    }, /*#__PURE__*/React.createElement(Box, {
      mr: 1
    }, children), /*#__PURE__*/React.createElement("span", null, "*")) : children);
  });
};

CheckboxOrRadioGroupLabel.displayName = "CheckboxOrRadioGroupLabel";
CheckboxOrRadioGroupLabel.defaultProps = {
  visuallyHidden: false
};
export default CheckboxOrRadioGroupLabel;